module.exports = __webpack_public_path__ + "img/n02.52b15df1.png";